export default function () {
    return {
        require: 'ngModel',
        link: function (scope, elm, attrs, ctrl) {
            ctrl.$validators.required = function (modelValue, viewValue) {
                return !((viewValue && viewValue.length === 0 || false) && attrs.multipleUiSelectRequired === 'true');
            };

            attrs.$observe('multipleUiSelectRequired', function () {
                ctrl.$setValidity('required', !(attrs.multipleUiSelectRequired === 'true' && ctrl.$viewValue && ctrl.$viewValue.length === 0));
            });
        }
    };
};
